export interface GifImagePartial {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    original_file_type: string
}

export const isGif = (image: GifImagePartial): boolean => image.original_file_type === 'image/gif'
